declare global {
  interface Window {
    __googleTranslateFixApplied?: boolean
  }
}

export const applyGoogleTranslateFix = () => {
    if (typeof window !== 'undefined' && 
        !window.__googleTranslateFixApplied
        // process.env.NODE_ENV === 'production'
    ) {
        const originalRemoveChild = Node.prototype.removeChild

        Node.prototype.removeChild = function <T extends Node>(child: T): T {
            try {
                return originalRemoveChild.call(this, child) as T
            } catch (error) {
                if (error.name === 'NotFoundError') {
                    return child
                }
                throw error
            }
        }

        const originalInsertBefore = Node.prototype.insertBefore

        Node.prototype.insertBefore = function (newNode, referenceNode) {
            try {
                return originalInsertBefore.call(this, newNode, referenceNode)
            } catch (error) {
                if (error.name === 'NotFoundError') {
                    return this.appendChild(newNode)
                }
                throw error
            }
        }

        window.__googleTranslateFixApplied = true
    }
}